import {createSelector} from 'reselect';
import props from '../../../../props';

export default createSelector(
    props.wallet.methods.cashapp_p2p_deposit,
    (cashapp_p2p_deposit) => {
        return {
            stage: cashapp_p2p_deposit.stage
        }
    }
)